import { GetPosParams } from "@bvhi/backend-api";
import { Button, Card, CardContent, CardHeader, Collapse, Grid, TextField } from "@bvhi/ui-base";
import { ClearIcon } from "@bvhi/ui-icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BVHIExpandComponent } from "../../../../../components/bvhi-expand-component";

interface Props {
  filter: GetPosParams;
  onChange: ({ key, value }: { key: string; value: string }) => void;
  onReset: () => void;
}

// TODO Add tests the card fields
export const PosFilterCard = ({ filter, onChange, onReset }: Props) => {
  const { t } = useTranslation(["pos"]);
  const [expanded, setExpanded] = useState<boolean>(false);

  return (
    <Card>
      <CardHeader
        restrictContentWidth={false}
        title={t("pos:pos.card.filter.title")}
        action={
          <Button color="secondary" endIcon={<ClearIcon />} onClick={onReset} variant="text">
            {t("pos:pos.card.filter.button.reset")}
          </Button>
        }
      />
      <CardContent>
        <Grid container pb={2} spacing={2}>
          <Grid xs={12}>
            <TextField
              fullWidth
              label={t("pos:pos.filter.searchtext.label")}
              placeholder={t("pos:pos.filter.searchtext.placeholder")}
              value={filter.searchString ?? ""}
              onChange={(e) => {
                onChange({ key: "searchString", value: e.target.value });
              }}
            />
          </Grid>
        </Grid>
        <BVHIExpandComponent expanded={expanded} setExpanded={setExpanded} />
        <Collapse in={expanded} timeout="auto">
          <Grid container spacing={2}>
            <Grid xs={6}>
              <TextField
                fullWidth
                label={t("pos:pos.filter.name.label")}
                placeholder={t("pos:pos.filter.name.placeholder")}
                value={filter.name ?? ""}
                onChange={(e) => {
                  onChange({ key: "name", value: e.target.value });
                }}
              />
            </Grid>
            <Grid xs={6}>
              <TextField
                fullWidth
                label={t("pos:pos.filter.postal.code.label")}
                placeholder={t("pos:pos.filter.postal.code.placeholder")}
                value={filter.postcode ?? ""}
                onChange={(e) => {
                  onChange({ key: "postcode", value: e.target.value });
                }}
              />
            </Grid>
          </Grid>
        </Collapse>
      </CardContent>
    </Card>
  );
};
